// Server-time anchor route (BL-596) — backs the admin clerk countdown's
// server-synced clock (`useServerNow` over @auctogon/time's createServerClock).
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { ServerTimeDto } from '../../schemas/responses/server-time';

export const time = defineAdminRoute({
  path: '/api/time',
  params: {},
  // Response DTO carrier (ADR 027 / BL-855): the client infers ServerTimeDto with
  // no <T>, and `respond()` type-checks the route against this same declaration.
  //
  // Declared, not bound (BL-1833 PR 3a): the connection-health probe calls this
  // on every page, the signed-out login page included, and the gate would 401
  // it. It returns the server clock and nothing else.
  methods: {
    GET: {
      grant: { none: 'public — the server clock; no user, tenant or database data' },
      tenant: { from: 'none', reason: 'public server clock — no user, tenant or database data' },
      response: responseType<ServerTimeDto>(),
    },
  },
});
